import { useCallback, useEffect, useState } from 'react';
import { SHELL_EXPANDED_KEY, tierForWidth } from './tokens.js';
function currentTier() {
    return typeof window === 'undefined' ? 'wide' : tierForWidth(window.innerWidth);
}
function readStored() {
    try {
        const raw = window.localStorage.getItem(SHELL_EXPANDED_KEY);
        return raw === null ? null : raw === 'true';
    }
    catch {
        return null;
    }
}
/**
 * The viewport tier alone — for feature code that swaps a presentation below a tier (the
 * People list becomes cards on phones) without spelling a pixel width.
 */
export function useShellTier() {
    const [tier, setTier] = useState(currentTier);
    useEffect(() => {
        const onResize = () => setTier(currentTier());
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);
    return tier;
}
/**
 * Tier from the viewport, plus the collapse preference. Defaults: expanded at wide, rail at desktop
 * and tablet; the stored choice overrides all three, so a menu opened at 768 to 1279 stays open and
 * the page makes room for it, as at wider widths (#754). It is one choice for every width with a side
 * menu. Mobile is always the drawer. No keyboard shortcut, no server field.
 */
export function useShellLayout() {
    const tier = useShellTier();
    const [stored, setStored] = useState(() => typeof window === 'undefined' ? null : readStored());
    const canToggle = tier !== 'mobile';
    const expanded = canToggle ? (stored ?? tier === 'wide') : false;
    const setExpanded = useCallback((next) => {
        setStored(next);
        try {
            window.localStorage.setItem(SHELL_EXPANDED_KEY, String(next));
        }
        catch {
            // Storage unavailable (private mode): the choice lasts for the session only.
        }
    }, []);
    return { tier, expanded, canToggle, setExpanded };
}
//# sourceMappingURL=useShellLayout.js.map